module.exports = __webpack_public_path__ + "img/srdickaS.739c1be3.png";